import { render, staticRenderFns } from "./RegularAlerts.vue?vue&type=template&id=04268506&"
import script from "./RegularAlerts.vue?vue&type=script&lang=js&"
export * from "./RegularAlerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports